

import React, { useEffect, useState,useMemo } from "react";
import { useNavigate , useParams} from "react-router-dom";
import { Api } from "../Api/Api";

const Advanced = () => {
  const [types, setTypes] = useState([]);
const [type, setType] = useState("all");

   const { id } = useParams();
   const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [advances, setAdvances] = useState([]);
  const [globalSearch, setGlobalSearch] = useState("");


  const currentUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("currentUser"));
    } catch {
      return null;
    }
  })();


  /* ADD ADVANCE FORM STATE */
  const [query, setQuery] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [advanceDate, setAdvanceDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  /* WEEK MODAL STATE */
  const [showModal, setShowModal] = useState(false);
  const [activeAdvance, setActiveAdvance] = useState(null);
  const [weekNo, setWeekNo] = useState("");
  const [weekDate, setWeekDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [weekAmount, setWeekAmount] = useState("");


  useEffect(() => {
  loadCustomers();
  loadAdvances();

  fetch(`${Api}customers/types/list.php`)
    .then((r) => r.json())
    .then((d) => setTypes(d.types || []));
}, []);



  const getCustomerId = (code) => {
    const c = customers.find((x) => x.customer_code === code);
    return c ? c.id : null;
  };


  const loadCustomers = async () => {
    
    const res = await fetch(`${Api}customers/list.php`);
    const data = await res.json();
    setCustomers(data.customers || []);
  };

  const loadAdvances = async () => {

    const res = await fetch(`${Api}advances/list.php`);
    const data = await res.json();
    setAdvances(data.advances || []);
  };




const customerTypeMap = useMemo(() => {
  const map = {};
  customers.forEach((c) => {
    map[c.customer_code] = c.type; // ✅ THIS is correct
  });
  return map;
}, [customers]);


const filteredAdvances = useMemo(() => {
  const q = globalSearch.toLowerCase();

  return advances.filter((a) => {
    const matchesSearch =
      !globalSearch ||
      a.name?.toLowerCase().includes(q) ||
      a.customer_code?.toLowerCase().includes(q);

    const customerType = customerTypeMap[a.customer_code];

    const matchesType =
      type === "all" ||
      customerType?.toLowerCase() === type.toLowerCase();

    return matchesSearch && matchesType;
  });
}, [advances, globalSearch, type, customerTypeMap]);




  /* LOGIC: Search through customers for the "Add" form */
  const customerSearchResults = customers.filter(
    (c) =>
      c.name.toLowerCase().includes(query.toLowerCase()) ||
      c.customer_code.toLowerCase().includes(query.toLowerCase()),
  );

  const submitAdvance = async () => {
    if (!selectedCustomer || !advanceAmount) {
      alert("Please select a customer and enter an amount");
      return;
    }

    await fetch(`${Api}advances/create.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customer_id: selectedCustomer.id,
        advance_amount: advanceAmount,
        advance_date: advanceDate,
        created_by: currentUser?.username || "",
        created_by_id: currentUser?.userId || 0,
      }),
    });
    setQuery("");
    setSelectedCustomer(null);
    setAdvanceAmount("");
    loadAdvances();
  };

  const openWeekModal = (a) => {
    setActiveAdvance(a);
    setWeekNo("");
    setWeekAmount("");
    setShowModal(true);
  };

  const submitWeek = async () => {
    if (!weekNo || !weekAmount) {
      alert("Fill all fields");
      return;
    }
    const remaining =
      Number(activeAdvance.advance_amount) -
      Number(activeAdvance.used_amount || 0);
    if (Number(weekAmount) > remaining) {
      alert("Amount exceeds remaining advance balance");
      return;
    }
  
    await fetch(`${Api}advances/add_week.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        advance_id: activeAdvance.id,
        week_no: weekNo,
        paid_amount: weekAmount,
        paid_date: weekDate,
        created_by: currentUser?.username || "",
        created_by_id: currentUser?.userId || 0,
      }),
    });
    setShowModal(false);
    loadAdvances();
  };


  const formatDateDMY = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};


useEffect(() => {
  if (advances.length) {
    console.log("ADVANCE SAMPLE:", advances[0]);
  }
}, [advances]);


  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* HEADER & GLOBAL SEARCH */}
       
<div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
  <h1 className="text-2xl font-extrabold text-slate-800">
    Advance Management
  </h1>

  <div className="flex gap-3 w-full md:w-auto">
    {/* SEARCH */}
    <input
      type="text"
      placeholder="Search by Name or Code..."
      value={globalSearch}
      onChange={(e) => setGlobalSearch(e.target.value)}
      className="w-full md:w-72 px-4 py-2 border border-slate-300 rounded-lg
                 focus:ring-2 focus:ring-indigo-500 outline-none"
    />

    {/* TYPE FILTER */}
    <select
      value={type}
      onChange={(e) => setType(e.target.value)}
      className="px-3 py-2 border border-slate-300 rounded-lg font-bold bg-white"
    >
      <option value="all">All Types</option>
      {types.map((t) => (
        <option key={t.id} value={t.type_name}>
          {t.type_name}
        </option>
      ))}
    </select>
  </div>
</div>

{/* RESULT COUNT */}
<div className="text-sm text-slate-500 font-medium">
  {filteredAdvances.length} results
</div>

        {/* SECTION: ADD ADVANCE FORM */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
          <h2 className="text-lg font-bold text-slate-700 mb-6 flex items-center gap-2">
            <span className="bg-indigo-100 text-indigo-600 p-1 rounded-md text-xs">
              NEW
            </span>
            Add Advance Amount
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="md:col-span-2 relative">
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                Customer
              </label>
              <input
                value={query}
                onChange={(e) => {
                  setQuery(e.target.value);
                  setSelectedCustomer(null);
                }}
                className="w-full border border-slate-300 px-4 py-2.5 rounded-lg focus:border-indigo-500 outline-none"
                placeholder="Start typing name or code..."
              />
              {query && !selectedCustomer && (
                <div className="absolute z-10 w-full bg-white border border-slate-200 rounded-lg mt-1 shadow-xl max-h-52 overflow-y-auto">
                  {customerSearchResults.map((c) => (
                    <div
                      key={c.id}
                      onClick={() => {
                        setSelectedCustomer(c);
                        setQuery(`${c.customer_code} - ${c.name}`);
                      }}
                      className="px-4 py-3 hover:bg-indigo-50 cursor-pointer text-sm border-b last:border-0 border-slate-100 transition-colors"
                    >
                      <span className="font-bold text-indigo-600">
                        {c.customer_code}
                      </span>{" "}
                      — {c.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                Advance Date
              </label>
              <input
                type="date"
                value={advanceDate}
                onChange={(e) => setAdvanceDate(e.target.value)}
                className="w-full border border-slate-300 px-4 py-2.5 rounded-lg focus:border-indigo-500 outline-none"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                Amount (₹)
              </label>
              <input
                type="number"
                value={advanceAmount}
                onChange={(e) => setAdvanceAmount(e.target.value)}
                className="w-full border border-slate-300 px-4 py-2.5 rounded-lg focus:border-indigo-500 outline-none"
                placeholder="0.00"
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={submitAdvance}
              className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl font-bold transition-all shadow-lg shadow-indigo-200 active:scale-95"
            >
              SAVE ADVANCE
            </button>
          </div>
        </div>

        {/* SECTION: ADVANCE LIST TABLE */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          {/* <div className="overflow-x-auto"> */}
          <div className="overflow-x-auto overflow-y-auto max-h-[70vh]">

            {/* <table className="w-full text-left border-collapse"> */}
            <table className="text-left border-collapse min-w-[1500px] w-full">

              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    #
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    Type
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    Advanced Date
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    Customer
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    Advance By
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase text-right">
                    Original
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase text-right">
                    Used
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase text-right">
                    Remaining
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase">
                    Week Breakdown
                  </th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase text-center">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-100">
                {filteredAdvances.map((a, i) => {
                  const total = Number(a.advance_amount);
                  const used = Number(a.used_amount || 0);
                  const remaining = total - used;

                  return (
                    <tr
                      key={a.id}
                      className="hover:bg-slate-50/50 transition-colors"
                    >
                      <td className="px-6 py-4 text-slate-400 font-medium">
                        {i + 1}
                      </td>
                     <td className="px-6 py-4 font-bold text-indigo-600 uppercase">
  {customerTypeMap[a.customer_code] || "-"}
</td>


                      <td className="px-6 py-4 text-slate-600 whitespace-nowrap">
                        {/* {a.advance_date} */}

                        {formatDateDMY(a.advance_date)}
                      </td>
                      

                      <td className="px-6 py-4">
                        <div className="font-bold text-slate-800">{a.name}</div>
                        <div className="text-xs text-slate-500 font-mono uppercase">
                          {a.customer_code}
                        </div>
                      </td>

                      <td className="px-6 py-4 text-sm">
                        {a.created_by ? (
                          <span className="font-semibold text-indigo-600">
                            {a.created_by}
                          </span>
                        ) : (
                          <span className="text-slate-400 italic">—</span>
                        )}
                      </td>

                      <td className="px-6 py-4 text-right font-medium text-slate-700">
                        ₹{total.toLocaleString()}
                      </td>

                      <td className="px-6 py-4 text-right font-medium text-red-500">
                        ₹{used.toLocaleString()}
                      </td>

                      <td className="px-6 py-4 text-right font-bold text-emerald-600">
                        ₹{remaining.toLocaleString()}
                      </td>

                      <td className="px-6 py-4 min-w-[340px]">
                        {a.weeks?.length ? (
                          <div className="bg-slate-50 rounded-lg border border-slate-200 overflow-hidden">
                            <div className="grid grid-cols-4 bg-slate-200/50 text-[10px] font-bold uppercase text-slate-600 px-2 py-1">
                              <span>Week</span>
                              <span className="text-right">Amt</span>
                              <span className="text-right">Date</span>
                              <span className="text-right">By</span>
                            </div>

                            {a.weeks.map((w) => (
                              <div
                                key={w.id}
                                className="grid grid-cols-4 px-2 py-1 text-xs border-t border-slate-200"
                              >
                                <span className="font-bold text-slate-700">
                                  W-{w.week_no}
                                </span>

                                <span className="text-right text-emerald-600 font-semibold">
                                  ₹{w.paid_amount}
                                </span>

                                <span className="text-right text-slate-500">
                                  {w.paid_date}
                                </span>

                                <span className="text-right text-indigo-600 font-semibold">
                                  {w.created_by || "—"}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span className="text-slate-400 italic text-xs">
                            No entries yet
                          </span>
                        )}
                      </td>

                      <td className="px-6 py-4 text-center space-y-2">
                        <button
                          onClick={() => openWeekModal(a)}
                          className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs font-bold block w-full"
                        >
                          + Week
                        </button>

                        <button
                          onClick={() => {
                            const cid = getCustomerId(a.customer_code);
                            if (!cid) {
                              alert("Customer not found");
                              return;
                            }
                            navigate(`/admin/customers/${cid}`);
                          }}
                          className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs font-bold block w-full"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {filteredAdvances.length === 0 && (
            <div className="p-12 text-center text-slate-400">
              No matching records found.
            </div>
          )}
        </div>
      </div>

      {/* MODAL: ADD WEEK */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50">
              <h3 className="font-bold text-slate-800 text-lg">
                Add Week Payment
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-slate-400 hover:text-slate-600 text-xl"
              >
                ×
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">
                  Week Number
                </label>
                <input
                  placeholder="e.g. 1"
                  type="number"
                  value={weekNo}
                  onChange={(e) => setWeekNo(e.target.value)}
                  className="w-full border border-slate-300 px-4 py-2.5 rounded-lg mt-1 outline-none focus:border-indigo-500"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">
                  Payment Date
                </label>
                <input
                  type="date"
                  value={weekDate}
                  onChange={(e) => setWeekDate(e.target.value)}
                  className="w-full border border-slate-300 px-4 py-2.5 rounded-lg mt-1 outline-none focus:border-indigo-500"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">
                  Amount Paid (₹)
                </label>
                <input
                  placeholder="0.00"
                  type="number"
                  value={weekAmount}
                  onChange={(e) => setWeekAmount(e.target.value)}
                  className="w-full border border-slate-300 px-4 py-2.5 rounded-lg mt-1 outline-none focus:border-indigo-500"
                />
              </div>
            </div>

            <div className="p-6 bg-slate-50 flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="px-6 py-2.5 text-slate-600 font-bold hover:bg-slate-200 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={submitWeek}
                className="px-6 py-2.5 text-slate-600 font-bold hover:bg-slate-200 rounded-lg transition-colors"
              >
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Advanced;
